import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useEffect } from 'react';
import { useTheme } from 'styled-components';
import { Flyout } from '@poplar/components/Flyout';
import { TopLevel } from './TopLevel';
import { useTranslation } from '@yoweb/next-i18next';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { TodoDiscovery } from './TodoDiscovery';
import { Box } from '@yoweb/ui/components/Box';
import { ActiveSlide } from './ActiveSlide';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Slide;

(function (Slide) {
  Slide["CATEGORY_SELECT"] = "category-select";
  Slide["SUB_CATEGORY"] = "sub-category";
  Slide["PRODUCT_DESCRIPTION"] = "product-description";
  Slide["TEMPLATED_TODO"] = "templated-todo";
})(Slide || (Slide = {}));

export var CreateTodoFlyout = function CreateTodoFlyout(props) {
  var isOpen = props.isOpen,
      initialTask = props.initialTask,
      initialTaskTemplateId = props.initialTaskTemplateId,
      initialCategoryId = props.initialCategoryId,
      initialSlide = props.initialSlide,
      onClose = props.onClose;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useExternalConfig = useExternalConfig(),
      globalFeatures = _useExternalConfig.globalFeatures;

  var theme = useTheme();

  var _useState = useState(),
      currentSlide = _useState[0],
      setCurrentSlide = _useState[1];

  var _useState2 = useState(false),
      doConfirmClose = _useState2[0],
      setDoConfirmClose = _useState2[1];

  var _useState3 = useState(initialCategoryId),
      categoryId = _useState3[0],
      setCategoryId = _useState3[1];

  var _useState4 = useState(initialTaskTemplateId),
      taskTemplateId = _useState4[0],
      setTaskTemplateId = _useState4[1];

  var _useState5 = useState(initialSlide || Slide.CATEGORY_SELECT),
      activeSlide = _useState5[0],
      setActiveSlide = _useState5[1];

  var resetState = function resetState() {
    return setCurrentSlide(null);
  };

  var confirmExit = function confirmExit(onExit) {
    return function (skipConfirmation) {
      if (!skipConfirmation && doConfirmClose) {
        var result = confirm(t('todo-intake.exit-warning'));

        if (!result) {
          return;
        }
      }

      onExit();
      setDoConfirmClose(false);
    };
  };

  var onSlideClose = confirmExit(function () {
    onClose(); // don't start changing slides while the flyout is closing

    setTimeout(function () {
      return !isOpen && resetState();
    }, theme.transitionDuration.interaction);
  });

  var setCurrentSlideToTemplated = function setCurrentSlideToTemplated() {
    setTaskTemplateId(undefined);
    setCurrentSlide(Slide.TEMPLATED_TODO);
  };

  useEffect(function () {
    if (initialTaskTemplateId && isOpen) {
      setTaskTemplateId(initialTaskTemplateId);
    }
  }, [isOpen, initialTaskTemplateId]);
  useEffect(function () {
    if (isOpen) {
      if (initialSlide) {
        setCurrentSlide(initialSlide);
      } else {
        if (initialTaskTemplateId || initialTask) {
          setTaskTemplateId(initialTaskTemplateId);
          setCurrentSlide(Slide.TEMPLATED_TODO);
        } else if (initialCategoryId) {
          setCurrentSlide(Slide.SUB_CATEGORY);
        } else {
          setCurrentSlide(Slide.CATEGORY_SELECT);
        }
      }

      setCategoryId(initialCategoryId);
      setDoConfirmClose(false);
    } else {
      resetState();
    }
  }, [isOpen, initialSlide, initialTaskTemplateId, initialTask, initialCategoryId]);
  useEffect(function () {
    if (currentSlide === Slide.SUB_CATEGORY && categoryId) {
      setActiveSlide(Slide.SUB_CATEGORY);
    } else if (currentSlide === Slide.PRODUCT_DESCRIPTION && taskTemplateId) {
      setActiveSlide(Slide.PRODUCT_DESCRIPTION);
    } else if (currentSlide === Slide.TEMPLATED_TODO) {
      setActiveSlide(Slide.TEMPLATED_TODO);
    } else {
      setActiveSlide(Slide.CATEGORY_SELECT);
    }
  }, [categoryId, currentSlide, taskTemplateId]);
  return /*#__PURE__*/_jsxs(Flyout, {
    isOpen: isOpen,
    onClose: onSlideClose,
    children: [!initialTask && /*#__PURE__*/_jsx(Box, {
      display: activeSlide === Slide.CATEGORY_SELECT ? 'block' : 'none',
      children: isOpen && (globalFeatures.enableTodoDiscovery ? /*#__PURE__*/_jsx(TodoDiscovery, {
        onClose: onSlideClose,
        onTemplateClicked: function onTemplateClicked(templateId, skipPdp) {
          setTaskTemplateId(templateId);

          if (skipPdp) {
            setCurrentSlide(Slide.TEMPLATED_TODO);
          } else {
            setCurrentSlide(Slide.PRODUCT_DESCRIPTION);
          }
        },
        onCreateCustomClicked: setCurrentSlideToTemplated
      }) : /*#__PURE__*/_jsx(TopLevel, {
        onClose: onSlideClose,
        onCreateCustomClicked: setCurrentSlideToTemplated,
        onCategoryClicked: function onCategoryClicked(newCategoryId) {
          setCategoryId(newCategoryId);
          setCurrentSlide(Slide.SUB_CATEGORY);
        }
      }))
    }), /*#__PURE__*/_jsx(ActiveSlide, _objectSpread({
      activeSlide: activeSlide,
      setDoConfirmClose: setDoConfirmClose,
      setCurrentSlide: setCurrentSlide,
      onSlideClose: onSlideClose,
      confirmExit: confirmExit,
      setTaskTemplateId: setTaskTemplateId,
      taskTemplateId: taskTemplateId,
      categoryId: categoryId,
      setCurrentSlideToTemplated: setCurrentSlideToTemplated
    }, props))]
  });
};